import { render } from "./BlankSecondaryTitle.vue?vue&type=template&id=19ded4e2"
import script from "./BlankSecondaryTitle.vue?vue&type=script&lang=js"
export * from "./BlankSecondaryTitle.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "19ded4e2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('19ded4e2', script)) {
    api.reload('19ded4e2', script)
  }
  
  module.hot.accept("./BlankSecondaryTitle.vue?vue&type=template&id=19ded4e2", () => {
    api.rerender('19ded4e2', render)
  })

}

script.__file = "src/views/misc/BlankSecondaryTitle.vue"

export default script